import React, { useState } from 'react';
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  alpha,
} from '@mui/material';
import BatchScheduleForm from './BatchScheduleForm';
import ScheduleCallForm from './ScheduleCallForm';

interface CombinedScheduleFormProps {
  onSuccess: () => void;
}

const CombinedScheduleForm: React.FC<CombinedScheduleFormProps> = ({ onSuccess }): JSX.Element => {
  const [isBatchMode, setIsBatchMode] = useState(true);
  const [selectedConfig, setSelectedConfig] = useState<{
    fromNumber: string;
    channelId: number;
    agentId: number | null;
  } | null>(() => {
    const savedConfig = localStorage.getItem('savedConfig');
    if (savedConfig) {
      try {
        const config = JSON.parse(savedConfig);
        return {
          fromNumber: config.fromNumber || '',
          channelId: config.channelId || 0,
          agentId: config.agentId || null
        };
      } catch (e) {
        return null;
      }
    }
    return null;
  });

  // If we have a saved config, show the main form directly
  const showMainForm = !!(selectedConfig?.fromNumber && selectedConfig?.channelId && selectedConfig?.agentId);

  if (!showMainForm) {
    return (
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <BatchScheduleForm 
          onSuccess={onSuccess} 
          onConfigSelected={(config) => {
            setSelectedConfig(config);
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>
      <Box sx={{ 
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2
      }}>
        <FormControlLabel
          control={
            <Switch
              checked={isBatchMode}
              onChange={(e) => setIsBatchMode(e.target.checked)}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#1e293b',
                  '& + .MuiSwitch-track': {
                    backgroundColor: '#1e293b',
                  },
                },
                '& .MuiSwitch-track': {
                  backgroundColor: alpha('#1e293b', 0.3),
                },
              }}
            />
          }
          label={
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {isBatchMode ? 'Batch Mode' : 'Single Call Mode'}
            </Typography>
          }
        />
      </Box>

      {isBatchMode ? (
        <BatchScheduleForm 
          onSuccess={onSuccess}
          initialConfig={selectedConfig}
        />
      ) : (
        <ScheduleCallForm 
          onSuccess={onSuccess}
          initialConfig={selectedConfig}
        />
      )}
    </Box>
  );
};

export default CombinedScheduleForm; 